import { sentryLogger } from "@robe/core-utils";

export const resolveApiUrl = () => {
  const publicApiUrl = process.env.NEXT_PUBLIC_BE_API;
  const internalApiUrl = process.env.INTERNAL_BE_API;

  if (internalApiUrl) {
    return internalApiUrl;
  }

  // Fallback to public BE api if internal BE API not available
  if (publicApiUrl) {
    process.env.NEXT_PUBLIC_DEBUG === "true" && console.warn("internal BE API env not available on server, using public BE API env");

    return publicApiUrl;
  }

  sentryLogger({
    error: new Error("internal BE API env and public BE API not available on server"),
    throwError: true,
    context: {
      publicApiUrl,
      internalApiUrl,
    },
  });

  throw new Error("BE API env not available");
};
